import { useCallback, useEffect, useMemo, useState } from "react";

import { MapLayerController } from "@/lib/map-layers";

import type { MapControlPanel } from "./map-control-tabs";

export function useMapControlLegendState(layers: MapLayerController[]) {
  const [activePanel, setActivePanel] = useState<MapControlPanel>("config");
  const [selectedLegendLayerId, setSelectedLegendLayerId] = useState<string | undefined>(
    undefined,
  );

  const hasLayersWithLegend = useMemo(
    () => layers.some((l) => l.isEnabled && l.renderedLegend != null),
    [layers],
  );

  useEffect(() => {
    if (!hasLayersWithLegend && activePanel === "legend") {
      setActivePanel("config");
    }
  }, [hasLayersWithLegend, activePanel]);

  const openLegend = useCallback((layerId: string) => {
    setSelectedLegendLayerId(layerId);
    setActivePanel("legend");
  }, []);

  return {
    activePanel,
    setActivePanel,
    selectedLegendLayerId,
    setSelectedLegendLayerId,
    hasLayersWithLegend,
    openLegend,
  };
}
